import React from 'react';
import {
    Sidebar,
    Menu,
    MenuItem,
    SidebarHeader,
    SidebarFooter,
    SubMenu

} from 'react-pro-sidebar';

import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { NavLink, useLocation, Link } from 'react-router-dom';
import Logo from '../images/logo.png';
import LogoSm from '../images/fav-icon.png';
import iconDashboard from '../images/Icons-dashboard.png';
import iconClient from '../images/Icons-clinet.png';
import iconSettings from '../images/Icons-settings.png';
import iconHelpAndSupport from '../images/Icons-helpandsupport.png';
import iconDocuments from '../images/Icons-dociments.png';
import './index.scss';



const SidebarMain = ({ sidebarState, toggleSidebar, sidebarRef, closeSidebarOnLinkClick }) => {

    const location = useLocation();

    const menuItem = [
        {
            path: "/engagements",
            name: "Engagements",
            icon: <img src={iconDashboard} alt="Dashboard" />

        },

        {
            path: "/clients",
            name: "Clients",
            icon: <img src={iconClient} alt="Client" />
        },
        {
            path: "/documentsummary",
            name: "Document Summary",
            icon: <img src={iconDocuments} alt="Document" />
        },
        {
            path: "/investment-schedules",
            name: "Investment Schedules",
            icon: <img src={iconDocuments} alt="Investment Schedules" />
        },
        {
            path: "/settings",
            name: "Settings",
            icon: <img src={iconSettings} alt="Settings" />
        },
        {
            path: "/help-support",
            name: "Help and Support",
            icon: <img src={iconHelpAndSupport} alt="Help and Support" />
        },

    ];



    const handleLinkClick = () => {
        if (sidebarState === 0) {
            closeSidebarOnLinkClick();

        }
    };

    return (

        <Sidebar
            toggled={sidebarState === 0}
            collapsed={sidebarState === 1}
            hidden={sidebarState === 2}
            onBackdropClick={toggleSidebar}
            breakPoint="md"
            className="custom-styles"
            ref={sidebarRef}
            // transitionDuration={200}

            rootStyles={{
                position: "sticky",
                top: 0,
                height: "100vh",
            }}
        >

            <div className="custom-header">
                {/* <div className="logotext">
                    {sidebarState !== 1 ? (
                        <img src={sidebarState === 0 ? Logo : Logo} alt="Logo" className='image-fluid w-100 py-2 px-3' />
                    ) : (
                        <img src={LogoSm} alt='Logo' className='image-fluid w-100 py-3 bg-white' />
                    )}
                </div> */}

                <div className="logotext">
                    <Link to="/engagements">
                        {sidebarState !== 1 ? (
                            <img
                                src={Logo}
                                alt="Logo"
                                className="image-fluid w-100"
                                style={{ padding: '10px' }}
                            />
                        ) : (
                            <img
                                src={LogoSm}
                                alt="Logo"
                                className="image-fluid w-100 py-3 bg-white"
                            />
                        )}
                    </Link>
                </div>



                <div className="position-relative pt-2">
                    <div
                        className="closemenu position-absolute"
                        style={{ zIndex: "999", right: 0, top: -20 }}
                        onClick={toggleSidebar}
                    >
                        {sidebarState === 0 ? <FaArrowLeft /> : <FaArrowRight />}
                    </div>
                </div>

            </div>

            <Menu iconShape="circle">
                {menuItem.map((item, index) => (
                    <MenuItem
                        key={index}
                        className={location.pathname.startsWith(item.path) ? 'active' : ''}
                        component={<NavLink to={item.path} onClick={handleLinkClick} />}
                    >
                        <div className="d-flex align-items-center">
                            <div
                                className={`icon my-auto ${sidebarState === 1 ? 'collapsed' : ''}`}
                                style={{ lineHeight: '100%' }}
                            >
                                {item.icon}
                            </div>
                            <div className={`link_text mx-2 ${sidebarState === 1 ? 'collapsed-text' : ''}`}>
                                {item.name}
                            </div>
                        </div>
                    </MenuItem>
                ))}
            </Menu>
        </Sidebar>
    );

};



export default SidebarMain;

